import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { UserService } from "../../../domain/user-service";
import { User } from "../../../domain/user";

@Component({
  selector: "icn-channel-first-timer",
  templateUrl: "first-timer.html",
  styleUrls: ["first-timer.scss"],
})
export class FirstTimerComponent implements OnInit {
  url = "/channels/new";

  currentUser: User;
  constructor(
    private router: Router,
    private userService: UserService,
  ) {}

  ngOnInit(): void {
    this.currentUser = this.userService.getCurrentUser();
  }
}
